<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌-육군본부, 육군 장병 취업역량 강화 '맞손'</h4>
                            <!-- <div class="board_meta">
                                <ul>
                                    <li>등록일 : 22.05.24</li>
                                    <li>조회수 : 142</li>
                                </ul>
                            </div> -->
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_10.png"></figure>
                                <br>
                                <br>
                                "종합교육기업 에듀윌이 육군본부와 손잡고 '육군 장병들의 취업역량 강화' 지원에 나선다.
                                <br><br>
                                12일 에듀윌에 따르면 육군본부와 업무협약을 체결하고, 장병들의 취업역량 강화와 안정적 사회 복귀를 위해 상호 협력한다.
                                <br><br>
                                에듀윌은 육군 장병들에게 40여 종의 온라인 강의와 학원 강의에 대해 특별 수강 혜택을 제공하기로 했다. 에듀윌의 전기기사와 산업안전기사 등 기술자격증과 행정사 등 전문자격증, 공무원 시험대비 과정, 토익, 공기업∙대기업 취업 과정 등의 학습 콘텐츠를 활용해 취업 스펙을 쌓을 수 있다.
                                <br><br>
                                이와 같은 수강 혜택은 전역 후에도 적용돼 전역 후 1년 이내의 육군 간부와 전역 후 2개월 이내의 장병이면 동일한 할인 혜택을 받을 수 있다.
                                <br><br>
                                아울러 에듀윌은 육군본부와 상호 친밀한 협조 체제를 유지하며, 전∙현역 장병들의 자기개발을 위한 교육 지원에 대해서도 지속적으로 협의해 나갈 계획이다.
                                <br><br>
                                에듀윌 관계자는 ""군 복무 중 여가시간에 취업에 필요한 자격증 취득이나 공무원시험 준비를 통해 제대 후 빠르게 취업 경쟁력을 갖추고 사회에 안정적으로 복귀하도록 돕고자 이번 협약을 체결하게 됐다""며 ""에듀윌의 지원으로 육군 장병들이 제대 후 고민없이 미래를 준비할 수 있길 바란다""고 말했다."
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news11" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 감정평가사 ? 노무사 신규 론칭…”전문직 자격증 시장에서도 우위 잡을 것</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news5" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, ESG 평가서 우수 등급 획득…교육업계 최고 수준</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},

	computed: {
	},

	methods: {
	},

	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })

		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });

		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
